module.exports = __webpack_public_path__ + "static/media/forest temple.9a2e66cc.webp";